import { render, staticRenderFns } from "./paperDialog.vue?vue&type=template&id=4b3ec184&scoped=true&"
import script from "./paperDialog.vue?vue&type=script&lang=js&"
export * from "./paperDialog.vue?vue&type=script&lang=js&"
import style0 from "./paperDialog.vue?vue&type=style&index=0&id=4b3ec184&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3ec184",
  null
  
)

export default component.exports